function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M295.678 375.55C300.209 373.068 304.643 370.41 308.941 367.596C336.908 349.358 359.89 324.378 375.794 294.933C391.698 265.488 400.02 232.512 400 199.009L399.5 199.009C399.5 199.01 399.5 199.01 399.5 199.011M295.678 375.55L399.5 199.011M295.678 375.55C271.071 389.059 243.893 397.172 215.938 399.355L295.678 375.55ZM399.5 199.011C398.981 146.183 377.733 95.6959 340.377 58.5243C303.019 21.352 252.572 0.5 200 0.5C147.428 0.5 96.9808 21.352 59.6235 58.5243C22.2666 95.6961 1.01906 146.183 0.5 199.011C0.5 202.102 0.500275 205.191 0.712677 208.179L0.713611 208.192C0.97205 213.987 1.50219 219.724 2.30381 225.402L2.30486 225.409C2.71852 228.696 3.22271 231.944 3.81734 235.152L3.81781 235.155C9.1461 264.751 21.0857 292.747 38.7377 317.035L38.7383 317.035C40.9108 320.037 43.1806 323.001 45.5087 325.886C64.6534 349.422 88.8567 368.291 116.3 381.077L116.301 381.078C118.92 382.306 121.576 383.475 124.27 384.566L124.273 384.567C148.279 394.462 173.982 399.535 199.93 399.5C202.816 399.487 205.552 399.428 208.139 399.324C210.725 399.22 213.312 399.064 215.898 398.856L215.899 398.856C243.784 396.679 270.892 388.587 295.437 375.112L295.437 375.112C299.958 372.636 304.381 369.985 308.668 367.177L308.668 367.177C336.565 348.984 359.49 324.068 375.354 294.695C391.219 265.324 399.519 232.43 399.5 199.011Z",
  fill: "#F2F5FE",
  stroke: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M264.481 143.778C287.005 143.778 305.265 125.429 305.265 102.794C305.265 80.1591 287.005 61.8101 264.481 61.8101C241.957 61.8101 223.697 80.1591 223.697 102.794C223.697 125.429 241.957 143.778 264.481 143.778Z",
  fill: "#D1EDF2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M264.502 142.077C286.081 142.077 303.574 124.498 303.574 102.813C303.574 81.1279 286.081 63.5488 264.502 63.5488C242.923 63.5488 225.43 81.1279 225.43 102.813C225.43 124.498 242.923 142.077 264.502 142.077Z",
  fill: "#EDF8F8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M264.503 137.719C257.625 137.723 250.901 135.677 245.18 131.841C239.459 128.004 234.999 122.549 232.363 116.165C229.728 109.781 229.035 102.756 230.373 95.9761C231.711 89.1968 235.02 82.9683 239.88 78.0785C244.741 73.1887 250.935 69.857 257.68 68.5049C264.425 67.1527 271.417 67.8408 277.773 70.4821C284.128 73.1235 289.562 77.5994 293.386 83.3438C297.21 89.0883 299.253 95.8434 299.257 102.755C299.257 112.021 295.597 120.909 289.08 127.464C282.564 134.02 273.724 137.709 264.503 137.719Z",
  fill: "#FDFEFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M265.027 68.9824H263.977V74.5134H265.027V68.9824Z",
  fill: "#CEEAE2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M236.342 102.286H230.838V103.341H236.342V102.286Z",
  fill: "#CEEAE2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M265.027 131.094H263.977V136.625H265.027V131.094Z",
  fill: "#CEEAE2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M298.148 102.286H292.645V103.341H298.148V102.286Z",
  fill: "#CEEAE2"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M278.252 103.322H263.977V83.856H265.007V102.286H278.252V103.322Z",
  fill: "#CEEAE2"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M277.084 100.585V105.021L280.449 102.793L277.084 100.585Z",
  fill: "#CEEAE2"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M262.285 85.9281H266.7L264.502 81.6479L262.285 85.9281Z",
  fill: "#CEEAE2"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M264.483 105.08C265.739 105.08 266.758 104.056 266.758 102.793C266.758 101.531 265.739 100.507 264.483 100.507C263.226 100.507 262.207 101.531 262.207 102.793C262.207 104.056 263.226 105.08 264.483 105.08Z",
  fill: "#CEEAE2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M241.959 112.233H131.238C127.65 112.233 124.742 115.156 124.742 118.761V199.732C124.742 203.337 127.65 206.26 131.238 206.26H241.959C245.547 206.26 248.455 203.337 248.455 199.732V118.761C248.455 115.156 245.547 112.233 241.959 112.233Z",
  fill: "#AAD4D6"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M243.282 116.709H129.896V200.436H243.282V116.709Z",
  fill: "#FAFBFB"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M181.437 161.091H175.395V163.963H181.437V161.091Z",
  fill: "#883883"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M171.404 151.006H168.544V157.078H171.404V151.006Z",
  fill: "#4106E7"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M164.55 161.091H158.508V163.963H164.55V161.091Z",
  fill: "#0075E7"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M177.07 153.365L172.797 157.659L174.819 159.691L179.092 155.397L177.07 153.365Z",
  fill: "#AD0CFF"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M162.88 153.364L160.857 155.396L165.13 159.69L167.152 157.657L162.88 153.364Z",
  fill: "#1126FF"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M172.662 162.372C172.662 161.836 172.504 161.313 172.207 160.867C171.911 160.422 171.49 160.075 170.998 159.87C170.505 159.665 169.964 159.611 169.441 159.716C168.918 159.82 168.438 160.078 168.061 160.457C167.684 160.836 167.427 161.318 167.323 161.844C167.219 162.369 167.273 162.913 167.477 163.408C167.681 163.903 168.026 164.326 168.469 164.624C168.912 164.921 169.434 165.08 169.967 165.08C170.681 165.08 171.367 164.795 171.872 164.287C172.378 163.779 172.662 163.09 172.662 162.372Z",
  fill: "#161946"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M186.445 158.785V163.931H184.295V151.008H189.004C191.441 151.008 193.053 152.664 193.053 154.896C193.053 157.128 191.443 158.785 189.004 158.785H186.445ZM188.684 156.876C190.046 156.876 190.87 156.121 190.87 154.914C190.87 153.707 190.046 152.916 188.684 152.916H186.445V156.876H188.684Z",
  fill: "#161946"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M196.286 151.008H194.208V163.927H196.286V151.008Z",
  fill: "#161946"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M206.136 161.414C205.671 162.944 204.291 164.187 202.194 164.187C199.83 164.187 197.732 162.458 197.732 159.487C197.732 156.714 199.775 154.878 201.98 154.878C204.667 154.878 206.244 156.657 206.244 159.434C206.25 159.657 206.231 159.881 206.189 160.1H199.812C199.828 160.72 200.087 161.309 200.533 161.737C200.98 162.166 201.577 162.4 202.194 162.387C203.448 162.387 204.094 161.721 204.381 160.856L206.136 161.414ZM204.147 158.569C204.111 157.542 203.43 156.626 201.998 156.626C201.462 156.614 200.943 156.809 200.546 157.171C200.15 157.532 199.906 158.032 199.865 158.569H204.147Z",
  fill: "#161946"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M209.515 159.509L206.398 155.169H208.87C209.032 155.443 210.627 157.726 210.787 157.978L212.687 155.169H215.051L211.989 159.472L215.159 163.938H212.723L210.698 161.003C210.519 161.277 208.889 163.668 208.727 163.938H206.344L209.515 159.509Z",
  fill: "#161946"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M86.9746 207.549H248.398V201.51H92.9842C91.392 201.515 89.8664 202.153 88.7405 203.284C87.6145 204.416 86.9797 205.949 86.9746 207.549Z",
  fill: "#AAD4D6"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M308.941 367.595C304.643 370.409 300.209 373.067 295.677 375.55L273.02 235.165L272.592 232.487L292.916 225.275L294.024 235.165L308.941 367.595Z",
  fill: "#AAD4D6"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M3.24883 235.166H327.516V208.215H0.214844C0.474159 214.013 0.979823 219.752 1.73184 225.433L3.24883 235.166Z",
  fill: "#C2ECF1"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M215.978 399.354C213.385 399.563 210.792 399.719 208.199 399.823L194.779 290.748H203.376L215.978 399.354Z",
  fill: "#A2D2DD",
  stroke: "#7793D8",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M116.148 381.53L125.562 290.748H127.351H134.158V290.787L124.142 385.028",
  fill: "#A2D2DD"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M116.148 381.53L125.562 290.748H127.351H134.158V290.787L124.142 385.028",
  stroke: "#7793D8",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M48.2703 290.748L45.1196 326.201C42.7858 323.308 40.5103 320.338 38.332 317.328L41.0159 290.748H48.2703Z",
  fill: "#A2D2DD",
  stroke: "#7793D8",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M92.655 161.895H28.2606C26.9222 161.918 25.6014 162.206 24.3737 162.741C23.1459 163.277 22.0353 164.051 21.1052 165.019C20.1751 165.986 19.4437 167.128 18.9529 168.379C18.462 169.631 18.2213 170.967 18.2445 172.312C18.2154 172.748 18.2154 173.185 18.2445 173.621L33.4922 283.068C33.7563 285.16 34.7677 287.084 36.3383 288.483C37.9089 289.882 39.9317 290.659 42.0302 290.671H123.676L92.655 161.895Z",
  fill: "#A2D2DD",
  stroke: "#7793D8",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M211.991 290.748C211.816 289.087 211.991 280.8 211.991 280.8L132.135 282.344C129.156 282.372 126.268 281.318 124.002 279.375C121.736 277.432 120.245 274.731 119.805 271.771L103.896 171.705C103.481 169.004 102.125 166.539 100.07 164.749C98.0144 162.959 95.3933 161.961 92.6738 161.933L110.041 274.585C110.672 279.037 112.864 283.116 116.223 286.087C119.583 289.058 123.888 290.725 128.362 290.787L211.991 290.748Z",
  fill: "#A2D2DD",
  stroke: "#7793D8",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M309.232 183.373C310.385 182.642 311.78 182.4 313.111 182.701C314.441 183.001 315.599 183.819 316.331 184.976C316.661 185.495 316.892 186.072 317.011 186.676C318.023 190.858 314.425 195.744 310.321 197.386C309.021 197.908 307.625 198.144 306.226 198.08C304.828 198.016 303.459 197.653 302.211 197.015",
  stroke: "#AFCDEC",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M299.606 200.065H274.926V206.847H299.606V200.065Z",
  fill: "#D1EDF2"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M276.034 184.039C275.49 180.697 273.564 177.335 274.556 174.091C275.263 172.467 276.207 170.959 277.357 169.615C277.933 168.942 278.36 168.152 278.608 167.299C278.857 166.446 278.921 165.55 278.796 164.67C278.232 162.403 275.781 161.27 274.089 159.667C272.709 158.282 271.807 156.49 271.513 154.552C271.219 152.615 271.549 150.634 272.456 148.898C274.009 146.475 276.262 144.586 278.913 143.485C281.48 142.234 284.203 141.296 286.692 139.81C291.632 136.742 294.861 131.582 298.945 127.439C301.997 124.39 305.533 121.874 309.408 119.993C315.009 117.315 322.069 116.182 327.223 119.68C328.289 120.334 329.135 121.294 329.654 122.436C329.985 123.416 330.098 124.456 329.985 125.485C329.708 131.15 327.613 136.574 324.014 140.944C322.497 142.898 321.311 143.758 321.116 146.221C320.902 149.211 322.575 151.185 322.944 154.038C323.372 157.244 320.669 160.038 317.771 161.407C314.873 162.775 311.586 163.361 308.844 164.964C307.999 165.382 307.316 166.069 306.899 166.918C306.685 167.504 306.685 168.149 306.491 168.736C305.791 170.69 303.185 171.198 301.104 171.726C298.601 172.386 296.301 173.662 294.413 175.44C292.525 177.218 291.108 179.441 290.29 181.908",
  fill: "#FAFBFB"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M310.573 175.986C310.573 175.986 310.204 192.677 303.261 198.482C298.861 202.357 293.113 204.325 287.274 203.954C279.008 203.954 274.866 201.491 271.268 198.482C264.344 192.618 263.955 175.986 263.955 175.986H310.573Z",
  fill: "#D1EDF2"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M264.482 181.83H310.051",
  stroke: "#AFCDEC",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M299.508 201.296C295.71 203.149 291.546 204.121 287.325 204.138C283.103 204.155 278.931 203.217 275.119 201.394",
  stroke: "#AFCDEC",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgLoggedOutArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 401,
    viewBox: "0 0 400 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggedOutArt);
export default __webpack_public_path__ + "static/media/logged_out_art.a713b9fe.svg";
export { ForwardRef as ReactComponent };